import moment from "moment";

export class DateParser {
  /**
   * Formats java date time formated string to german or other formated date
   * @param javaDate {@link string} eg: '2024-11-19T09:20:00+00:00' or {@link number} timestamp: '1732004400'
   * @param lang {@link string} eg: 'de' If not provided the german formating will be returned
   * @returns formated date eg: '19.11.2024'
   */
  static javaDateToReadableDate(javaDate: string | number, lang?: string): string {
    if (!lang || lang?.toLowerCase() === "de") {
      return moment(javaDate).format("DD.MM.YYYY");
    }
    return moment(javaDate).format("DD/MM/YYYY");
  }
  /**
   * Extracts from java date time and formats to 'HH:mm:ss'
   * @param javaDate {@link string} eg: '2024-11-19T09:20:00+00:00' or {@link number} timestamp: '1732004400'
   * @returns formated time eg: '09:20:00'
   */
  static javaDateToReadableTime(javaDate: string | number): string {
    return moment(javaDate).format("HH:mm:ss");
  }
  /**
   * Formats java date time formated string to german or other formated date time
   * @param javaDate {@link string} eg: '2024-11-19T09:20:00+00:00' or {@link number} timestamp: '1732004400'
   * @param lang {@link string} eg: 'de' If not provided the german formating will be returned
   * @returns formated date time '19.11.2024 09:20:00'
   */
  static javaDateToReadableDateTime(javaDate: string | number, lang?: string): string {
    if (!lang || lang?.toLowerCase() === "de") {
      return moment(javaDate).format("DD.MM.YYYY HH:mm:ss");
    }
    return moment(javaDate).format("DD/MM/YYYY HH:mm:ss");
  }
}
